import { render, staticRenderFns } from "./PublicityNotice.vue?vue&type=template&id=998f836a&scoped=true&"
import script from "./PublicityNotice.vue?vue&type=script&lang=js&"
export * from "./PublicityNotice.vue?vue&type=script&lang=js&"
import style0 from "./PublicityNotice.vue?vue&type=style&index=0&id=998f836a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998f836a",
  null
  
)

export default component.exports